/* @flow */
import * as React from 'react';

import BoxBody from 'components/BoxBody.jsx';
import CurrentUser from 'auth/CurrentUser';
import Dialog from 'components/Dialog.jsx';
import SignInForm from 'auth/components/SignInForm.jsx';

type Props = {
  email: string,
  onRequestHide: Function,
  onSignedIn: Function,
};

class SignInModal extends React.Component<Props> {
  static defaultProps = {
    email: '',
    onSignedIn: () => {},
    onRequestHide: () => {},
  };

  componentDidMount() {
    CurrentUser.addSignInListener(this.onSignedIn);
    CurrentUser.addSignInNoRoleListener(this.onSignedIn);
  }

  componentWillUnmount() {
    CurrentUser.removeSignInListener(this.onSignedIn);
    CurrentUser.removeSignInNoRoleListener(this.onSignedIn);
  }

  onSignedIn = () => {
    this.props.onSignedIn();
    this.props.onRequestHide();
  };

  render() {
    return (
      <Dialog eventScreenName="SignInModal" {...this.props} size="small" className="SignInModal">
        <BoxBody>
          <SignInForm uid={this.props.email} />
        </BoxBody>
      </Dialog>
    );
  }
}

export default SignInModal;
